module.exports = __webpack_public_path__ + "media/sizzle.396d95ac.mp4";